import React from 'react';

function EventStaffAssignedListItemBadges(props) {
  const item = props.item;
  const event = props.event;

  return (
    <div className="staff-members-badges d-flex align-items-center">
      { item.working_status === 'Inactive' &&
      <span className="badge badge_inactive">
          <i className="fas fa-ban" title="Inactive staff"></i>
        </span>
      }
      { item.type === 'Staff' && item.public_facing &&
        <span className="badge badge-public-facing">
          <i className="fas fa-user-tie" title="Public facing"></i>
        </span>
      }
      { item.department_id && item.department_id !== event.department_id &&
        <span className="badge badge-travel">
          <i className="fas fa-plane" title="Shared Resource"></i>
        </span>
      }
      { item.type === 'Volunteer' &&
        <span className="badge badge-volunteer" title="Volunteer">
          <i className="fas fa-hands-helping" title="Volunteer"></i>
        </span>
      }
      { item.is_overnight &&
        <span className="badge badge-overnight">
          <i className="fas fa-solid fa-moon" title="Overnight shift"></i>
        </span>
      }
    </div>
  )
}

export default EventStaffAssignedListItemBadges;
